(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-description-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-description-scroll')) {
    class ProductDescriptionScroll extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-product-description-button]');
        this.button?.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.handleClick);
      }

      getHeaderOffset(rawTop, currentY) {
        const alwaysSticky = document.body.classList.contains('kt-header-is-sticky');
        const stickyOnScrollUp = document.body.classList.contains('kt-header-is-sticky-when-scrolling');
        const movesUp = rawTop < currentY;
        if (!alwaysSticky && !(stickyOnScrollUp && movesUp)) return 0;

        const header = document.getElementById('header-element');
        if (!header) return 0;

        const computedTop = Number.parseFloat(window.getComputedStyle(header).top);
        const topInset = Number.isFinite(computedTop) ? Math.max(0, computedTop) : 0;
        const obstruction = Math.ceil(header.getBoundingClientRect().height + topInset) + 1;
        const stickyThreshold = document.getElementById('shopify-section-header')?.offsetTop ?? 0;

        return rawTop - obstruction >= stickyThreshold ? obstruction : 0;
      }

      handleClick = (event) => {
        const productId = this.dataset.productId;
        if (!productId) return;

        const target = document.querySelector(`product-details[data-product-id="${productId}"]`);
        if (!target) return;

        event.preventDefault();

        requestAnimationFrame(() => {
          const scrollRoot = target.closest('.kt-section.product-details') || target;
          const currentY = window.scrollY;
          const rawTop = scrollRoot.getBoundingClientRect().top + currentY;
          const headerOffset = this.getHeaderOffset(rawTop, currentY);
          const maxTop = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
          const top = Math.min(maxTop, Math.max(0, rawTop - headerOffset));
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          target.focus({ preventScroll: true });
          window.scrollTo({ top, behavior: reducedMotion ? 'auto' : 'smooth' });
        });
      };
    }

    customElements.define('product-description-scroll', ProductDescriptionScroll);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ring-builder-placement"] && !Shopify.designMode) return;
  try {
    if (typeof customElements.get('ring-builder-placement') === 'undefined') {
    const iframeOriginKey = Symbol('ringBuilderIframeOrigin');
    const iframeReadyKey = Symbol('ringBuilderIframeReady');
    const iframeHiddenStateKey = Symbol('ringBuilderIframeHiddenState');
    const readyEvent = 'user:theme_colors_updated';
    const revealFallbackDelay = 3000;

    class RingBuilderPlacement extends HTMLElement {
      connectedCallback() {
        this.isParkingIframe = false;
        this.moveIframe = this.moveIframe.bind(this);
        this.handleSectionUnload = this.handleSectionUnload.bind(this);
        this.handleBridgeMessage = this.handleBridgeMessage.bind(this);
        this.observer = new MutationObserver(this.moveIframe);
        this.observer.observe(document.querySelector('main') || document.body, {
          childList: true,
          subtree: true
        });
        document.addEventListener('shopify:section:unload', this.handleSectionUnload);
        window.addEventListener('message', this.handleBridgeMessage);
        this.moveIframe();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('shopify:section:unload', this.handleSectionUnload);
        window.removeEventListener('message', this.handleBridgeMessage);
        this.clearRevealWork();
        this.parkIframe();
      }

      clearRevealWork() {
        window.clearTimeout(this.revealFallbackTimer);
        window.cancelAnimationFrame(this.firstRevealFrame);
        window.cancelAnimationFrame(this.secondRevealFrame);
        this.revealFallbackTimer = undefined;
        this.firstRevealFrame = undefined;
        this.secondRevealFrame = undefined;
      }

      getIframeOrigin(iframe) {
        try {
          return new URL(iframe.src, window.location.href).origin;
        } catch (error) {
          return null;
        }
      }

      handleBridgeMessage(event) {
        const iframe = this.currentIframe;
        const packet = event.data;

        if (!iframe || event.source !== iframe.contentWindow) return;
        if (event.origin !== this.getIframeOrigin(iframe)) return;
        if (!packet || packet.__iframeBridge !== true || packet.version !== 1 || packet.kind !== 'event') return;
        if (packet.event !== readyEvent) return;

        this.queueReveal(iframe);
      }

      rememberIframeHiddenState(iframe) {
        if (iframe[iframeHiddenStateKey]) return;

        iframe[iframeHiddenStateKey] = {
          hadAriaHidden: iframe.hasAttribute('aria-hidden'),
          ariaHidden: iframe.getAttribute('aria-hidden'),
          hadInert: iframe.hasAttribute('inert')
        };
      }

      hideIframe(iframe) {
        this.rememberIframeHiddenState(iframe);
        iframe.setAttribute('aria-hidden', 'true');
        iframe.setAttribute('inert', '');
        this.setAttribute('data-ring-builder-loading', '');
        this.removeAttribute('data-ring-builder-ready');
        this.setAttribute('aria-busy', 'true');
      }

      restoreIframeHiddenState(iframe) {
        const hiddenState = iframe[iframeHiddenStateKey];
        if (!hiddenState) return;

        if (hiddenState.hadAriaHidden) {
          iframe.setAttribute('aria-hidden', hiddenState.ariaHidden ?? '');
        } else {
          iframe.removeAttribute('aria-hidden');
        }

        if (!hiddenState.hadInert) iframe.removeAttribute('inert');
        delete iframe[iframeHiddenStateKey];
      }

      prepareIframe(iframe) {
        if (this.currentIframe === iframe) return;

        this.clearRevealWork();
        if (this.currentIframe) this.restoreIframeHiddenState(this.currentIframe);
        this.currentIframe = iframe;

        if (iframe[iframeReadyKey]) {
          this.revealIframe(iframe);
          return;
        }

        this.hideIframe(iframe);
        this.revealFallbackTimer = window.setTimeout(() => this.queueReveal(iframe), revealFallbackDelay);
      }

      queueReveal(iframe) {
        if (this.currentIframe !== iframe || iframe[iframeReadyKey]) return;

        window.clearTimeout(this.revealFallbackTimer);
        window.cancelAnimationFrame(this.firstRevealFrame);
        window.cancelAnimationFrame(this.secondRevealFrame);
        this.firstRevealFrame = window.requestAnimationFrame(() => {
          this.secondRevealFrame = window.requestAnimationFrame(() => this.revealIframe(iframe));
        });
      }

      revealIframe(iframe) {
        iframe[iframeReadyKey] = true;
        if (this.currentIframe !== iframe) return;

        this.clearRevealWork();
        this.restoreIframeHiddenState(iframe);
        this.removeAttribute('data-ring-builder-loading');
        this.setAttribute('data-ring-builder-ready', '');
        this.removeAttribute('aria-busy');

        if (this.dataset.keyideasRingBuilderEligible !== 'true') return;
        if (typeof window.injectChooseSettingButton !== 'function') return;

        try {
          window.injectChooseSettingButton();
        } catch (error) {
          console.warn('KeyIdeas choose-setting action could not be refreshed.', error);
        }
      }

      handleSectionUnload(event) {
        if (event.target instanceof Element && event.target.contains(this)) {
          this.parkIframe();
        }
      }

      rememberIframeOrigin(iframe) {
        if (iframe[iframeOriginKey]?.isConnected || !iframe.parentNode) return;

        const anchor = document.createComment('Keyideas ring builder original position');
        iframe.parentNode.insertBefore(anchor, iframe);
        iframe[iframeOriginKey] = anchor;
      }

      parkIframe() {
        this.isParkingIframe = true;
        this.observer?.disconnect();
        this.clearRevealWork();

        const iframe = this.querySelector('#ringBuilderIframe');
        if (!iframe) return;

        const replacement = document.querySelector('ring-builder-placement');
        if (replacement && replacement !== this) {
          replacement.append(iframe);
          this.currentIframe = null;
          return;
        }

        this.restoreIframeHiddenState(iframe);

        const anchor = iframe[iframeOriginKey];
        if (anchor?.isConnected && anchor.parentNode) {
          anchor.parentNode.insertBefore(iframe, anchor.nextSibling);
          this.currentIframe = null;
          return;
        }

        document.querySelector('main')?.prepend(iframe);
        this.currentIframe = null;
      }

      moveIframe() {
        if (this.isParkingIframe) return;
        if (document.querySelector('ring-builder-placement') !== this) return;

        const iframe = document.getElementById('ringBuilderIframe');
        if (iframe) {
          this.prepareIframe(iframe);
        }

        if (iframe && iframe.parentElement !== this) {
          this.rememberIframeOrigin(iframe);
          this.append(iframe);
        }
      }
    }

    customElements.define('ring-builder-placement', RingBuilderPlacement);
  }
  } catch(e) { console.error(e); }
})();

})();
